
import { ofList, tryFind, ofSeq } from "./fable_modules/fable-library-js.5.0.0/Map.js";
import { int64ToString, compareArrays, int32ToString, equals, comparePrimitives } from "./fable_modules/fable-library-js.5.0.0/Util.js";
import { defaultArg } from "./fable_modules/fable-library-js.5.0.0/Option.js";
import { HtmlHelper_createElement } from "./fable_modules/Feliz.3.3.3/./Html.fs.js";
import { map as map_1, indexed, isEmpty, ofArray, singleton } from "./fable_modules/fable-library-js.5.0.0/List.js";
import { map, empty, append, collect, singleton as singleton_1, delay, toList } from "./fable_modules/fable-library-js.5.0.0/Seq.js";
import { isNullOrWhiteSpace, join, concat } from "./fable_modules/fable-library-js.5.0.0/String.js";
import { GlyphKind } from "../../../NetHack.Api/Domain.fs.js";
import { rangeDouble } from "./fable_modules/fable-library-js.5.0.0/Range.js";
import { max, min } from "./fable_modules/fable-library-js.5.0.0/Double.js";
import { FSharpSet__Contains, ofArray as ofArray_1 } from "./fable_modules/fable-library-js.5.0.0/Set.js";
import { indexed as indexed_1 } from "./fable_modules/fable-library-js.5.0.0/Array.js";
import { fromInt32, toInt64_unchecked, compare } from "./fable_modules/fable-library-js.5.0.0/BigInt.js";
import { Message } from "./Message.fs.js";

const palette = ofSeq([["black", "#7d8cbd"], ["red", "#ef6b6b"], ["green", "#4ecc60"], ["brown", "#c78c3d"], ["blue", "#5f92e4"], ["magenta", "#c96fd8"], ["cyan", "#36bcbc"], ["gray", "#b4bdc7"], ["no-color", "#d3dae1"], ["orange", "#ef9a4b"], ["bright-green", "#6ce478"], ["yellow", "#f0dc66"], ["bright-blue", "#8ec4ff"], ["bright-magenta", "#ec8ff4"], ["bright-cyan", "#75e9e9"], ["white", "#ffffff"]], {
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
});

function colorOf(name) {
    return defaultArg(tryFind(name, palette), "#d3dae1");
}

function capitalize(str) {
    if (str.length === 0) {
        return str;
    }
    else {
        return str[0].toLocaleUpperCase() + str.slice(1, str.length);
    }
}

function hungerText(_arg) {
    switch (_arg.tag) {
        case 1:
            return "Not hungry";
        case 2:
            return "Hungry";
        case 3:
            return "Weak";
        case 4:
            return "Fainting";
        case 5:
            return "Fainted";
        case 6:
            return "Starved";
        default:
            return "Satiated";
    }
}

function conditionText(_arg) {
    switch (_arg.tag) {
        case 1:
            return "Sliming";
        case 2:
            return "Strangled";
        case 3:
            return "Food poisoning";
        case 4:
            return "Terminally ill";
        case 5:
            return "Blind";
        case 6:
            return "Deaf";
        case 7:
            return "Stunned";
        case 8:
            return "Confused";
        case 9:
            return "Hallucinating";
        case 10:
            return "Levitating";
        case 11:
            return "Flying";
        case 12:
            return "Riding";
        case 13:
            return "Held";
        case 14:
            return "Holding";
        case 15:
            return "Trapped";
        case 16:
            return "Paralyzed";
        case 17:
            return "Sleeping";
        case 18:
            return "Unconscious";
        case 19:
            return "Bare-handed";
        default:
            return "Petrifying";
    }
}

function isAlarming(_arg) {
    switch (_arg.tag) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 16:
        case 17:
        case 18:
        case 15:
        case 13:
            return true;
        default:
            return false;
    }
}

function kindText(_arg) {
    switch (_arg.tag) {
        case 1:
            return "monster";
        case 2:
            return "pet";
        case 3:
            return "object";
        case 4:
            return "terrain";
        case 5:
            return "feature";
        case 6:
            return "trap";
        case 7:
            return "sensed";
        case 8:
            return "unexplored";
        default:
            return "you";
    }
}

function panel(title, body) {
    return HtmlHelper_createElement("div", ofArray([["className", "panel"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "panel-head"], ["children", singleton(title)]])), body]]]));
}

function renderMessages(obs) {
    return panel("Messages", HtmlHelper_createElement("div", ofArray([["className", "panel-body messages-box"], ["children", toList(delay(() => (isEmpty(obs.Messages) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", "empty"], ["children", singleton("None this turn.")]]))) : singleton_1(HtmlHelper_createElement("div", ofArray([["className", "messages"], ["children", toList(delay(() => collect((matchValue) => {
        const msg = matchValue[1];
        const isSystem = msg.startsWith("!");
        return singleton_1(HtmlHelper_createElement("div", ofArray([["key", matchValue[0]], ["className", isSystem ? "message system" : "message"], ["children", singleton(isSystem ? msg.slice(1, msg.length) : msg)]])));
    }, indexed(obs.Messages))))]]))))))]])));
}

function renderCell(legend, x, y, entity, ch) {
    let matchValue;
    const symbol = ch;
    const pos = `(${x},${y})`;
    let patternInput;
    if (entity == null) {
        patternInput = ["cell", undefined, (matchValue = tryFind(symbol, legend), (matchValue == null) ? pos : concat(pos, " ", ...matchValue))];
    }
    else {
        const ent = entity;
        const className = join(" ", toList(delay(() => append(singleton_1("cell"), delay(() => append(equals(ent.Kind, new GlyphKind(0, [])) ? singleton_1("hero") : singleton_1("ent"), delay(() => append(!ent.InView ? singleton_1("faded") : empty(), delay(() => (ent.Pile ? singleton_1("pile") : empty()))))))))));
        const name = defaultArg(ent.Name, kindText(ent.Kind));
        const tip = join("", toList(delay(() => append(singleton_1(pos), delay(() => append(singleton_1(` ${name} (${kindText(ent.Kind)})`), delay(() => append(ent.Pile ? singleton_1(" — topmost of a pile") : empty(), delay(() => (!ent.InView ? singleton_1(" — remembered, not in view") : empty()))))))))));
        patternInput = [className, colorOf(ent.Color), tip];
    }
    return HtmlHelper_createElement("span", toList(delay(() => append(singleton_1(["key", x]), delay(() => append(singleton_1(["className", patternInput[0]]), delay(() => {
        let matchValue_1;
        return append((matchValue_1 = patternInput[1], (matchValue_1 == null) ? (empty()) : singleton_1(["style", {
            color: matchValue_1,
        }])), delay(() => append(singleton_1(["title", patternInput[2]]), delay(() => singleton_1(["children", singleton(symbol)])))));
    })))))));
}

function renderRulers(width) {
    const ruler = (digit) => HtmlHelper_createElement("div", ofArray([["className", "map-row map-ruler"], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("span", singleton(["className", "map-gutter"]))), delay(() => append(map((x) => HtmlHelper_createElement("span", ofArray([["key", x], ["className", "cell"], ["children", singleton(digit(x))]])), rangeDouble(0, 1, width - 1)), delay(() => singleton_1(HtmlHelper_createElement("span", singleton(["className", "map-gutter right"])))))))))]]));
    return ofArray([ruler((x_1) => (((x_1 % 10) === 0) ? int32ToString(~~(x_1 / 10)) : " ")), ruler((x_2) => int32ToString(x_2 % 10))]);
}

function renderMap(obs) {
    const entities = ofList(map_1((ent) => [[ent.Pos.X, ent.Pos.Y], ent], obs.Entities), {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    });
    return HtmlHelper_createElement("div", ofArray([["className", "panel"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "map-scroll"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "map"], ["children", toList(delay(() => append(renderRulers(obs.Width), delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", "map-grid"], ["children", toList(delay(() => collect((matchValue) => {
        const y_1 = matchValue[0] | 0;
        const row = matchValue[1];
        return singleton_1(HtmlHelper_createElement("div", ofArray([["key", y_1], ["className", "map-row"], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("span", ofArray([["className", "map-gutter"], ["children", singleton(int32ToString(y_1))]]))), delay(() => append(collect((x_1) => {
            const ch = (x_1 < row.length) ? row[x_1] : " ";
            return singleton_1(renderCell(obs.Legend, x_1, y_1, tryFind([x_1, y_1], entities), ch));
        }, rangeDouble(0, 1, obs.Width - 1)), delay(() => singleton_1(HtmlHelper_createElement("span", ofArray([["className", "map-gutter right"], ["children", singleton(int32ToString(y_1))]])))))))))]])));
    }, indexed(obs.Rows))))]]))), delay(() => renderRulers(obs.Width)))))))]]))]]]))]]]));
}

function promptParts(_arg) {
    switch (_arg.tag) {
        case 1:
            return ["Direction", _arg.fields[0]];
        case 2: {
            const dflt = _arg.fields[2];
            return ["Choice", `${_arg.fields[0]} [${_arg.fields[1]}${(dflt == null) ? "" : (`, default ${dflt}`)}]`];
        }
        case 3:
            return ["Quantity", _arg.fields[0]];
        case 4:
            return ["Text", _arg.fields[0]];
        case 5:
            return ["Menu", `${_arg.fields[0]} (${_arg.fields[1]})`];
        case 6:
            return ["More", "--More--"];
        case 7:
            return ["Game over", _arg.fields[0]];
        default:
            return ["Command", "Ready for a command."];
    }
}

function renderPrompt(pending) {
    const patternInput = promptParts(pending);
    return HtmlHelper_createElement("div", ofArray([["className", "panel"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "panel-body"], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("div", singleton(["children", [HtmlHelper_createElement("span", ofArray([["className", (pending.tag === 7) ? "prompt-kind over" : "prompt-kind"], ["children", singleton(patternInput[0])]])), HtmlHelper_createElement("span", ofArray([["className", "prompt-text"], ["children", singleton(patternInput[1])]]))]]))), delay(() => {
        const matchValue = pending;
        if (matchValue.tag === 5) {
            return singleton_1(HtmlHelper_createElement("ul", ofArray([["className", "menu"], ["children", toList(delay(() => collect((matchValue_1) => {
                const item = matchValue_1[1];
                return singleton_1(HtmlHelper_createElement("li", ofArray([["key", matchValue_1[0]], ["className", !item.Selectable ? "heading" : (item.Selected ? "selected" : "")], ["children", [HtmlHelper_createElement("span", ofArray([["className", "menu-key"], ["children", singleton(item.Selectable ? item.Key : "")]])), HtmlHelper_createElement("span", singleton(["children", singleton(item.Text)]))]]])));
            }, indexed(matchValue.fields[2]))))]])));
        }
        else {
            return empty();
        }
    }))))]]))]]]));
}

function noteCheck(flag) {
    return HtmlHelper_createElement("td", ofArray([["className", "note-check"], ["children", toList(delay(() => (flag ? singleton_1(HtmlHelper_createElement("input", ofArray([["type", "checkbox"], ["checked", true], ["readOnly", true]]))) : empty())))]]));
}

const noteMaxAge = 10;

function noteOpacity(age) {
    return 1 - (0.4 * (min(age, noteMaxAge) / noteMaxAge));
}

function noteRow(key, id, note, relevant, delete$) {
    return HtmlHelper_createElement("tr", ofArray([["key", key], ["style", {
        opacity: noteOpacity(note.Age),
    }], ["children", [HtmlHelper_createElement("td", ofArray([["className", "note-id"], ["children", singleton(id)]])), HtmlHelper_createElement("td", ofArray([["className", "note-text"], ["children", singleton(note.Text)]])), HtmlHelper_createElement("td", ofArray([["className", "note-age"], ["children", singleton(int32ToString(note.Age))]])), noteCheck(relevant), noteCheck(delete$)]]]));
}

function renderNotes(session) {
    const relevant = ofArray_1(session.RelevantNotes, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const toDelete = ofArray_1(session.NotesToDelete, {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    return panel("Agent\'s Notes", HtmlHelper_createElement("div", ofArray([["className", "panel-body scroll notes-box"], ["children", toList(delay(() => (((session.CurrentNotes.length === 0) && (session.NotesToAdd.length === 0)) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", "empty"], ["children", singleton("Nothing noted.")]]))) : singleton_1(HtmlHelper_createElement("table", ofArray([["className", "notes"], ["children", [HtmlHelper_createElement("thead", singleton(["children", [HtmlHelper_createElement("tr", singleton(["children", toList(delay(() => map((name) => HtmlHelper_createElement("th", ofArray([["key", name], ["children", singleton(name)]])), ["ID", "Text", "Age", "Relevant", "Delete"])))]))]])), HtmlHelper_createElement("tbody", singleton(["children", toList(delay(() => append(collect((matchValue) => {
        const i = matchValue[0] | 0;
        return singleton_1(noteRow(`cur${i}`, int32ToString(i + 1), matchValue[1], FSharpSet__Contains(relevant, i), FSharpSet__Contains(toDelete, i)));
    }, indexed_1(session.CurrentNotes)), delay(() => collect((matchValue_1) => singleton_1(noteRow(`new${matchValue_1[0]}`, "New", matchValue_1[1], false, false)), indexed_1(session.NotesToAdd))))))]))]]]))))))]])));
}

function renderAction(session) {
    return panel("Agent\'s Decision", HtmlHelper_createElement("div", ofArray([["className", "panel-body"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "acts"], ["children", toList(delay(() => collect((matchValue) => {
        const label = matchValue[0];
        return append(singleton_1(HtmlHelper_createElement("div", ofArray([["key", label], ["className", "act-label"], ["children", singleton(label)]]))), delay(() => singleton_1(HtmlHelper_createElement("div", ofArray([["key", label + "-v"], ["className", matchValue[2]], ["children", singleton(matchValue[1])]])))));
    }, [["Action", session.Action, "act-text"], ["Expected", session.Prediction, "act-prose"]])))]]))]]])));
}

function meter(label, value, maxValue, fillClass) {
    const pct = (maxValue <= 0) ? 0 : min(100, max(0, (value / maxValue) * 100));
    return HtmlHelper_createElement("div", ofArray([["className", "meter"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "meter-label"], ["children", [HtmlHelper_createElement("span", singleton(["children", singleton(label)])), HtmlHelper_createElement("span", singleton(["children", singleton(`${value} / ${maxValue}`)]))]]])), HtmlHelper_createElement("div", ofArray([["className", "meter-track"], ["children", [HtmlHelper_createElement("div", ofArray([["className", `meter-fill ${fillClass}`], ["style", {
        width: pct + "%",
    }]]))]]]))]]]));
}

function stat(name, value) {
    return HtmlHelper_createElement("div", ofArray([["className", "stat"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "stat-name"], ["children", singleton(name)]])), HtmlHelper_createElement("div", ofArray([["className", "stat-value"], ["children", singleton(value)]]))]]]));
}

function renderVitals(obs) {
    const ch = obs.Character;
    const st = obs.Status;
    let hpClass;
    const frac = (st.HPMax > 0) ? (st.HP / st.HPMax) : 0;
    hpClass = ((frac > 0.5) ? "hp-good" : ((frac > 0.25) ? "hp-warn" : "hp-bad"));
    let expStr;
    const matchValue = st.Experience;
    let matchResult, experience_1;
    if (matchValue != null) {
        if (compare(matchValue, toInt64_unchecked(fromInt32(0))) > 0) {
            matchResult = 0;
            experience_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            expStr = (`${st.ExpLevel} (${experience_1})`);
            break;
        }
        default:
            expStr = int32ToString(st.ExpLevel);
    }
    const facts = toList(delay(() => append(singleton_1(["Role", capitalize(ch.Role)]), delay(() => append(singleton_1(["Race", capitalize(ch.Race)]), delay(() => append(singleton_1(["Gender", capitalize(ch.Gender)]), delay(() => append(singleton_1(["Align", capitalize(st.Alignment)]), delay(() => append(singleton_1(["AC", int32ToString(st.ArmorClass)]), delay(() => append(singleton_1(["Exp", expStr]), delay(() => append(singleton_1(["Gold", `$${st.Gold}`]), delay(() => append(singleton_1(["Level", int32ToString(st.DungeonLevel)]), delay(() => append(singleton_1(["Depth", int32ToString(st.Depth)]), delay(() => append(singleton_1(["Turn", int64ToString(st.Turns)]), delay(() => append(singleton_1(["Position", `(${obs.Hero.X}, ${obs.Hero.Y})`]), delay(() => append(singleton_1(["Hunger", hungerText(st.Hunger)]), delay(() => {
        let matchValue_1;
        return append((matchValue_1 = st.Encumbrance, (matchValue_1 == null) ? (empty()) : singleton_1(["Encumbrance", matchValue_1])), delay(() => {
            const matchValue_2 = st.Score;
            if (matchValue_2 == null) {
                return empty();
            }
            else {
                return singleton_1(["Score", int64ToString(matchValue_2)]);
            }
        }));
    }))))))))))))))))))))))))));
    return panel("Vitals", HtmlHelper_createElement("div", ofArray([["className", "panel-body"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "who"], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", "who-title"], ["children", singleton(st.Title)]]))), delay(() => (!isNullOrWhiteSpace(st.Dungeon) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", "who-sub"], ["children", singleton(st.Dungeon)]]))) : empty())))))]])), meter("HP", st.HP, st.HPMax, hpClass), meter("POWER", st.Power, st.PowerMax, "pw"), HtmlHelper_createElement("div", ofArray([["className", "stats"], ["children", [stat("STR", st.Strength), stat("DEX", int32ToString(st.Dexterity)), stat("CON", int32ToString(st.Constitution)), stat("INT", int32ToString(st.Intelligence)), stat("WIS", int32ToString(st.Wisdom)), stat("CHA", int32ToString(st.Charisma))]]])), HtmlHelper_createElement("dl", ofArray([["className", "facts"], ["children", toList(delay(() => collect((matchValue_3) => {
        const name = matchValue_3[0];
        return append(singleton_1(HtmlHelper_createElement("dt", ofArray([["key", name], ["children", singleton(name)]]))), delay(() => singleton_1(HtmlHelper_createElement("dd", ofArray([["key", name + "-v"], ["children", singleton(matchValue_3[1])]])))));
    }, facts)))]]))]]])));
}

function renderConditions(conditions) {
    return panel("Conditions", HtmlHelper_createElement("div", ofArray([["className", "panel-body"], ["children", toList(delay(() => (isEmpty(conditions) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", "empty"], ["children", singleton("None.")]]))) : singleton_1(HtmlHelper_createElement("div", ofArray([["className", "chips"], ["children", toList(delay(() => map((cond) => HtmlHelper_createElement("span", ofArray([["key", conditionText(cond)], ["className", isAlarming(cond) ? "chip alert" : "chip"], ["children", singleton(conditionText(cond))]])), conditions)))]]))))))]])));
}

function renderInventory(items) {
    return panel("Inventory", HtmlHelper_createElement("div", ofArray([["className", "panel-body scroll"], ["children", toList(delay(() => (isEmpty(items) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", "empty"], ["children", singleton("Carrying nothing.")]]))) : singleton_1(HtmlHelper_createElement("div", ofArray([["className", "rows"], ["children", toList(delay(() => map((item) => HtmlHelper_createElement("div", ofArray([["key", item.Letter], ["className", "row-item"], ["children", [HtmlHelper_createElement("span", ofArray([["className", "row-key"], ["children", singleton(item.Letter)]])), HtmlHelper_createElement("span", singleton(["children", singleton(item.Text)]))]]])), items)))]]))))))]])));
}

function renderGameState(inner, dispatch) {
    const gameState = inner.SessionState;
    const obs = gameState.Observation;
    return HtmlHelper_createElement("div", ofArray([["className", inner.Busy ? "app busy" : "app"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "layout"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "column"], ["children", [renderMap(obs), HtmlHelper_createElement("div", ofArray([["className", "subcolumns"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "column"], ["children", [renderNotes(gameState)]]])), HtmlHelper_createElement("div", ofArray([["className", "column"], ["children", [renderMessages(obs), renderPrompt(gameState.Pending), renderAction(gameState), HtmlHelper_createElement("footer", ofArray([["className", "footer"], ["children", [HtmlHelper_createElement("button", ofArray([["className", "button icon"], ["disabled", inner.Busy], ["title", "Rewind to start"], ["onClick", (_arg) => {
        dispatch(new Message(3, []));
    }], ["children", singleton("⏮")]])), HtmlHelper_createElement("button", ofArray([["className", "button icon"], ["disabled", inner.Busy], ["title", "Previous state"], ["onClick", (_arg_1) => {
        dispatch(new Message(2, []));
    }], ["children", singleton("⏴")]])), HtmlHelper_createElement("button", ofArray([["className", "button"], ["disabled", inner.Busy], ["onClick", (_arg_2) => {
        dispatch(new Message(1, []));
    }], ["children", singleton(inner.Busy ? "Thinking…" : "Next")]])), HtmlHelper_createElement("button", ofArray([["className", "button icon"], ["disabled", inner.Busy], ["title", "Fast forward"], ["onClick", (_arg_3) => {
        dispatch(new Message(4, []));
    }], ["children", singleton("⏭")]]))]]]))]]]))]]]))]]])), HtmlHelper_createElement("div", ofArray([["className", "column"], ["children", [renderVitals(obs), renderConditions(obs.Status.Conditions), renderInventory(obs.Inventory)]]]))]]])), HtmlHelper_createElement("a", ofArray([["className", "colophon"], ["href", "https://github.com/brianberns/NetHack-FSharp"], ["target", "_blank"], ["rel", "noopener noreferrer"], ["children", singleton("Source code and documentation")]]))]]]));
}

export function render(state, dispatch) {
    if (state.tag === 1) {
        return HtmlHelper_createElement("div", ofArray([["className", "notice error"], ["children", singleton(state.fields[0])]]));
    }
    else if (state.fields[0] != null) {
        return renderGameState(state.fields[0], dispatch);
    }
    else {
        return HtmlHelper_createElement("div", ofArray([["className", "notice"], ["children", singleton("Entering the dungeon…")]]));
    }
}

